// Entry point of the browser application

import isNode from 'detect-node';
import {createRoot} from 'react-dom/client';
import Modal from 'react-modal';

import {initGoogleMapsAPI} from 'App/externals/googlemaps/googleMapsAPILoader';

import {oneClickLCA} from '../apps/standalone/src/shared/lib/one-click-lca';

import {initBuildrzAxios} from './app/clients/buildrzAxios';
import App from './app/main/app';
import initSentry from './app/monitoring/sentry';
import {initRestClient} from './clients/rest_client';
import {DOM_ID} from './constants';
import {loadConfig} from './load_config';

import 'App/main/i18n';
import 'App/main/styles';

if (isNode) {
  console.error(
    "Node processes shouldn't even see this file.",
    'The loaded Sentry lib might be incorrect',
  );
}

// We got bugs after migrating to React 18.1.0, so we have to rollback to React 17.0.2.
// Problems:
// 1) There are other objects in street names screenshot, so it overlays ground
//     plan and parking visuals;
// 2) Toastify bugs (endless notifications, slow loading, remain after error is
//    fixed). Possible temporary solution: disable strict mode.

loadConfig().then(config => {
  initSentry(config);
  initRestClient(config);
  initBuildrzAxios(config);
  initGoogleMapsAPI();
  oneClickLCA.integrations.init(
    'https://oneclicklcaapp.com',
    config.oneClickLCAIntegrationSecurityToken || '',
  );

  const mainView = document.getElementById(DOM_ID.mainView);
  const root = createRoot(mainView);
  root.render(<App tab="home" />);
  Modal.setAppElement(mainView);
});
